import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteVehicleCCRes;
export const DeleteVehicleCCTodo = createAsyncThunk('AddCategory', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `vehicle_cc/${id}`,
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteVehicleCCRes = res.data
        
    } catch (error) {
        return DeleteVehicleCCRes = error.response.data
    }
})
